import React, { useCallback } from 'react';
import { Link }               from 'react-router-dom';
import ReadingTimeIcon        from '../../../components/icons/ReadingTimeIcon';
import { useCommon }          from '../../../providers/common';

const NewsItem = function(props) {
  const {
          date,
          image,
          label,
          readingTime,
          urlKey,
          type,
        } = props;

  const { pages } = useCommon();

  const getUrlByType = useCallback(() => {
    const template = type === 3 ? 'akcii' : 'news';
    const url      = pages.find(page => page.template === template)?.urlKey;
    return url ? `/${url}/${urlKey}` : '/';
  }, [pages, urlKey, type]);

  return (
    <Link className={'newsItem'} to={getUrlByType()}>
      <img
        className={'newsItem_img'}
        src={`${image}.png?default=horizontal&t=${BUILD_TIME}`}
        alt={label}
      />
      <div className={'newsItem_time'}>
        <p className={'newsItem_time_date'}>{date}</p>
        {readingTime && (
          <div className={'reading_time_wrapper'}>
            <ReadingTimeIcon />
            <p className={'reading_time'}>{readingTime}</p>
          </div>)}
      </div>
      <h3 className={'newsItem_time_title'}>{label}</h3>
    </Link>
  );
};

export default NewsItem;